module.exports = __webpack_public_path__ + "assets/home.svg";


//////////////////
// WEBPACK FOOTER
// ./libs/images/home.svg
// module id = 351
// module chunks = 0